import React from "react";
import {
  Badge,
  Box,
  IconButton,
  Paper,
  Stack,
  Typography,
  MailIcon,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const BasicBadge = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Badge
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <Typography variant="body1" fontSize={14}>
            Basic Badge
          </Typography>
          <PreviewAndEditor
            language={"js"}
            value={
              "            <Badge badgeContent={4}>\n" +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "\n" +
              '            <Badge badgeContent={4} color="primary">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "\n" +
              '            <Badge badgeContent={4} color="secondary">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "\n" +
              '            <Badge badgeContent={4} color="error">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "            \n" +
              '            <Badge badgeContent={4} color="warning">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "            \n" +
              '            <Badge badgeContent={4} color="info">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "            \n" +
              '            <Badge badgeContent={4} color="success">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>"
            }
          >
            <Badge badgeContent={4}>
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="primary">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="secondary">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="error">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="warning">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="info">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="success">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>
          </PreviewAndEditor>
        </Box>

        <Box>
          <Typography variant="body1" fontSize={14}>
            Dot Badge
          </Typography>
          <PreviewAndEditor

            language={"js"}
            value={
              '          <Badge badgeContent={4} color="primary" variant="dot">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "\n" +
              '            <Badge badgeContent={4} color="secondary" variant="dot">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "\n" +
              '            <Badge badgeContent={4} color="error" variant="dot">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "            \n" +
              '            <Badge badgeContent={4} color="warning" variant="dot">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "            \n" +
              '            <Badge badgeContent={4} color="info" variant="dot">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>\n" +
              "            \n" +
              '            <Badge badgeContent={4} color="success" variant="dot">\n' +
              '              <IconButton size="small">\n' +
              '                <MailIcon color="action" />\n' +
              "              </IconButton>\n" +
              "            </Badge>"
            }
          >
            <Badge badgeContent={4} color="primary" variant="dot">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="secondary" variant="dot">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="error" variant="dot">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="warning" variant="dot">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="info" variant="dot">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>

            <Badge badgeContent={4} color="success" variant="dot">
              <IconButton size="small">
                <MailIcon color="action" />
              </IconButton>
            </Badge>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default BasicBadge;
